/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { widgetCostsConfiguration } from '../../../../PageDashboard/components/Widgets/WidgetCosts/constant/widgetCostsConstants';
import { IWidgetConfiguration } from '../../../../PageDashboard/components/Widgets/WidgetCosts/types/widgetCostsType';

export const SubscriberIdFinanceConfiguration: IWidgetConfiguration = {
    ...widgetCostsConfiguration,
    chart: {
        ...widgetCostsConfiguration.chart,
        legendSize: 8,
    },
};
